import React from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next';

const useFetchDestinationsFeatured = () => {
    const [destinationsFeatured, setDestinationsFeatured] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const { i18n } = useTranslation();

    const fetchDestinationsFeatured = React.useCallback(async () => {
        setIsLoading(true);
        const { REACT_APP_BASE_URL } = process.env
        const token = localStorage.getItem('token');
        const params = {
            lng: i18n.language
        }
        if (!token) return;

        try {
            const { data } = await axios.get(
                `${REACT_APP_BASE_URL}/index.php?r=api/tours/destinationsfeatured`,
                {
                    headers: {
                        'x-authorization-token': token
                    },
                    params: params
                }
            ) || {}

            setIsLoading(false)
            if (data.length) {
                setDestinationsFeatured(data)
            }
        } catch (err) {
            console.error('Error fetching destinations featured: ', err)
            setIsLoading(false)
        }
    }, [])

    React.useEffect(() => {
        fetchDestinationsFeatured()
    }, [fetchDestinationsFeatured])

    return {
        destinationsFeatured,
        isLoading,
    }
}

export default useFetchDestinationsFeatured
